import { render } from "./FooterView.vue?vue&type=template&id=3ba60f1c"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=3ba60f1c&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuestx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__